export interface AssetForSiteDesignModel {
  id?: string;
  serialNumber?: string;
  lockedToSite?: boolean;
  ordered?: boolean;
  installed?: boolean;
  deviceId?: string;
  assetId?: string;
  installDate?: string;
  updatedDate?: string;
  isFutureFleet?: string;
  productNumber?: string;
  description?: string;
  solutionId?: string;
  bundleNumbers?: string;
  deviceKey?: string;
  hasDisposition?: boolean;
  enableCatalogPricing?: boolean;
  friendlyName?: string;
  type: "asset" | "accessory";
  accessories: AssetForSiteDesignModel[];
  assetShouldBeAccessory?: boolean;
  quicksilver?: boolean;
}

export function assetForSiteDesignModelFactory(json?: any): AssetForSiteDesignModel {
  json = json || {};

  return {
    id: json.id || "",
    serialNumber: json.serialNumber || "",
    lockedToSite: !!json.lockedToSite,
    ordered: !!json.ordered,
    installed: !!json.installed,
    deviceId: json.deviceId || "",
    assetId: json.assetId || "",
    installDate: json.installDate || "",
    updatedDate: json.updatedDate || "",
    isFutureFleet: json.isFutureFleet || "",
    productNumber: json.productNumber || "",
    description: json.description || "",
    solutionId: json.solutionId || "",
    bundleNumbers: json.bundleNumbers || "",
    deviceKey: json.deviceKey || "",
    hasDisposition: !!json.hasDisposition,
    enableCatalogPricing: !!json.enableCatalogPricing,
    friendlyName: json.friendlyName || "",
    type: json.type,
    accessories: Array.from(json.accessories || [])
      .map(it => assetForSiteDesignModelFactory(it)) as AssetForSiteDesignModel[],
    assetShouldBeAccessory: !!json.assetShouldBeAccessory,
    quicksilver: !!json.quicksilver,
  } as AssetForSiteDesignModel;
}

export function assetForSiteDesignModelListFactory(json?: any): AssetForSiteDesignModel[] {
  return Array.from(json || []).map(it => assetForSiteDesignModelFactory(it)) as AssetForSiteDesignModel[];
}
